// extracted by mini-css-extract-plugin
export default {"rating":"GB-z","numberOfStars":"HB-z","count":"IB-z","barGraphSpacing":"JB-z","barGraph":"KB-z"};